import React from 'react';
import { Paper, InputBase, IconButton, alpha, useTheme } from '@mui/material';
import { Search as SearchIcon, Close as CloseIcon } from '@mui/icons-material';

interface SiteSearchBarProps {
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
}

/**
 * 현장 목록 검색 입력창. 상태/디바운스는 호출자(useSiteManagement)가 담당.
 * 이 컴포넌트는 순수 controlled input 역할만 수행.
 */
const SiteSearchBar: React.FC<SiteSearchBarProps> = ({
  value,
  onChange,
  placeholder = '현장 이름 또는 위치로 검색',
}) => {
  const theme = useTheme();

  return (
    <Paper
      elevation={0}
      sx={{
        display: 'flex',
        alignItems: 'center',
        px: 2,
        py: 0.5,
        borderRadius: 2,
        bgcolor: alpha(theme.palette.background.paper, 0.6),
        border: `1px solid ${alpha(theme.palette.divider, 0.4)}`,
        transition: 'border-color 150ms ease',
        '&:focus-within': {
          borderColor: theme.palette.primary.main,
        },
      }}
    >
      <SearchIcon sx={{ color: theme.palette.text.secondary, mr: 1 }} />
      <InputBase
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        inputProps={{ 'aria-label': 'site search' }}
        sx={{ flex: 1, color: theme.palette.text.primary }}
      />
      {value.length > 0 && (
        <IconButton
          size="small"
          onClick={() => onChange('')}
          aria-label="clear search"
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      )}
    </Paper>
  );
};

export default SiteSearchBar;
